import { faTable } from "@fortawesome/pro-duotone-svg-icons/faTable";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_ARTIFACTS_LINK: Breadcrumb = {
  icon: faTable,
  name: "Artifacts",
  to: "/dashboard/artifacts",
};
